let mapClasses = require('../../actions/custom-order/map-classes');
let { calcPriceGroup } = require('../groups/order');
let analytics = require('../../actions/analytics');
let utils = require('../../actions/utils');

module.exports = {
    onItemCheck: [
        mapClasses.changeValue,
        ...calcPriceGroup
    ],

    onSetAll: [
        mapClasses.setAll,
        ...calcPriceGroup
    ]
};



// WEBPACK FOOTER //
// ./signals/custom-order/map-classes.js